import {Field} from "./interfaces";
import {PartialTheme} from "../../../clients/shadow/interfaces";

export function createField(name: string, partialTheme: PartialTheme, path: string, setColor: (partialTheme: PartialTheme
        , paper: string) => void): Field {
    return {
        name,
        path,
        currentColor: getValueByObjectPath(partialTheme, path),
        defaultColor: getValueByObjectPath(partialTheme, path),
        setColor
    }
}

function getValueByObjectPath(obj: any, path: string) {
    return path.split('.').reduce((value, pathPart) => {
        try {
            return value[pathPart];
        } catch (err) {
            throw err;
        }
    }, obj);
}
